module.exports = __webpack_public_path__ + "static/media/logos.eab7aa50.jpg";